/**
 * Created by mauget on 8/25/16.
 */

import xjService    from 'xml/XJService.js';
import _            from 'lodash';
import constants    from 'Constants.js';
import Immutable    from 'immutable';
import listService  from 'ListService.js';
import dateUtil from 'shared/DateUtil.js';
import specialFormList  from 'SpecialFormList.js';

const map = Immutable.Map([
    ['script_abs', ['Number']],
    ['script_average', ['List']],
    ['script_browsertype', ['']],
    ['script_browserversion', ['']],
    ['script_ceil', ['Number']],
    ['script_combine', ['Parameter 1','Parameter 2','Parameter 3','Parameter 4','Parameter 5']],
    ['script_count', ['List']],
    ['script_dateadd', ['Date','Amount', 'Unit']],
    ['script_datediff', ['Date 1', 'Date 2', 'Unit']],
    ['script_getday', ['Date']],
    ['script_querystringdecode', ['QueryString', 'Parameter name']],
    ['script_floor', ['Number']],
    ['script_getcustomparameter', ['Parameter name']],
    ['script_getexternalcallparameter', ['Parameter index']],
    ['script_geturlparameter', ['Parameter name']],
    ['script_getage', ['Date of birth']],
    ['script_getexactday', ['Date']],
    ['script_getexactmonth', ['Date']],
    ['script_getexactyear', ['Date']],
    ['script_gethours', ['Date']],
    ['script_indexof', ['Text','Search text']],
    ['script_ishtml', ['']],
    ['script_ismobile', ['']],
    ['script_join', ['List']],
    ['script_lastindexof', ['Text','Search text']],
    ['script_ltrim', ['Text']],
    ['script_length', ['Value']],
    ['script_lower', ['Text']],
    ['script_max', ['List']],
    ['script_min', ['List']],
    ['script_getminutes', ['Date']],
    ['script_mod', ['Number','Number']],
    ['script_getmonth', ['Date']],
    ['script_getmonthname', ['Date']],
    ['script_power', ['Number', 'Number']],
    ['script_random', ['Minimum','Maximum']],
    ['script_replace', ['Text','Pattern', 'Replace text', 'Flags']],
    ['script_rtrim', ['Text']],
    ['script_round', ['Number','Digits']],
    ['script_search', ['Text', 'Pattern', 'Flags']],
    ['script_getseconds', ['Date']],
    ['script_squareroot', ['Number']],
    ['script_substring', ['Text', 'Start index', 'End index']],
    ['script_substr', ['Text', 'Start index', 'Length']],
    ['script_sum', ['List']],
    ['script_timediff', ['Time 1', 'Time 2', 'Unit']],
    ['script_trim', ['Text']],
    ['script_upper', ['Text']],
    ['script_urldecode', ['Text']],
    ['script_urlencode', ['Text']],
    ['script_getutc', ['Date']],
    ['script_getdayname', ['Date']],
    ['script_getdayofweek', ['Date']],
    ['script_getyear', ['Date']]
]);

const mapNames = Immutable.Map([
    ['script_abs', 'Absolute'],
    ['script_average', 'Average'],
    ['script_browsertype', 'Browser Type'],
    ['script_browserversion', 'Browser Version'],
    ['script_ceil', 'Ceiling'],
    ['script_combine', 'Concatenation'],
    ['script_count', 'Count'],
    ['script_dateadd', 'Date Add'],
    ['script_datediff', 'Date Difference'],
    ['script_getday', 'Day'],
    ['script_querystringdecode', 'Extract QueryString Parameter'],
    ['script_floor', 'Floor'],
    ['script_getcustomparameter', 'Get Custom Parameter'],
    ['script_getexternalcallparameter', 'Get External Call Parameter'],
    ['script_geturlparameter', 'Get URL Parameter'],
    ['script_getage', 'GetAge'],
    ['script_getexactday', 'GetExactDay'],
    ['script_getexactmonth', 'GetExactMonth'],
    ['script_getexactyear', 'GetExactYear'],
    ['script_gethours', 'Hours'],
    ['script_indexof', 'Index Of'],
    ['script_ishtml', 'IsHtml'],
    ['script_ismobile', 'IsMobile'],
    ['script_join', 'Join'],
    ['script_lastindexof', 'Last Index Of'],
    ['script_ltrim', 'Left Trim'],
    ['script_length', 'Length'],
    ['script_lower', 'Lower Case'],
    ['script_max', 'Maximum'],
    ['script_min', 'Minimum'],
    ['script_getminutes', 'Minutes'],
    ['script_mod', 'Modulo'],
    ['script_getmonth', 'Month'],
    ['script_getmonthname', 'Month Name'],
    ['script_power', 'Power'],
    ['script_random', 'Random'],
    ['script_replace', 'Replace'],
    ['script_rtrim', 'Right Trim'],
    ['script_round', 'Round'],
    ['script_search', 'Search'],
    ['script_getseconds', 'Seconds'],
    ['script_squareroot', 'Square Root'],
    ['script_substring', 'Sub-Text 1'],
    ['script_substr', 'Sub-Text 2'],
    ['script_sum', 'Sum'],
    ['script_timediff', 'Time Difference'],
    ['script_trim', 'Trim'],
    ['script_upper', 'Upper Case'],
    ['script_urldecode', 'URL-decode'],
    ['script_urlencode', 'URL-encode'],
    ['script_getutc', 'UTC'],
    ['script_getdayname', 'Weekday Name'],
    ['script_getdayofweek', 'Weekday Number'],
    ['script_getyear', 'Year']
]);


const mapNamesDataSource = Immutable.Map([
    ['script_abs', 'Absolute'],
    ['script_ceiling', 'Ceiling'],
    ['script_currentdate', 'Current Date'],
    ['script_currentTime', 'Current Time'],
    ['script_dateadd', 'Date Add'],
    ['script_datediff', 'Date Difference'],
    ['script_day', 'Day'],
    ['script_floor', 'Floor'],
    ['script_ltrim', 'Left Trim'],
    ['script_len', 'Length'],
    ['script_lower', 'Lower Case'],
    ['script_month', 'Month'],
    ['script_power', 'Power'],
    ['script_rtrim', 'Right Trim'],
    ['script_round', 'Round'],
    ['script_square', 'Square'],
    ['script_sqrt', 'Square Root'],
    ['script_substring', 'Sub String'],
    ['script_upper', 'Upper Case'],
    ['script_year', 'Year']
]);


const mapFunctionsDataSource = Immutable.Map([
    ['script_abs', ['Number']],
    ['script_ceiling', ['Number']],
    ['script_currentdate', []], 
    ['script_currentTime', []],
    ['script_dateadd', ['Date','Amount', 'Unit']],
    ['script_datediff', ['Date 1', 'Date 2', 'Unit']],
    ['script_day', ['Date']],
    ['script_floor', ['Number']],
    ['script_ltrim', ['Text']],
    ['script_len', ['Text']],
    ['script_lower', ['Text']],
    ['script_month', ['Date']],
    ['script_power', ['Source number', 'Power']],
    ['script_rtrim', ['Text']],
    ['script_round', ['Number']],
    ['script_square', ['Number']],
    ['script_sqrt', ['Number']],
    ['script_substring', ['Source string', 'Start index', 'Length']],
    ['script_upper', ['Text']],
    ['script_year', ['Date']]
]);

//========================================================================================
// Process certain XML elements to control ordering across JS <--> XML converstions
// The idea is to make XML names that maintain their order when converted to JS objects.
//
// The issue was that <E><A/><O/></A></E> converts to { E: [A:{}, A:{}], O:{} }.
// We need a JS object  { E: {A1:{}, O:{}, A2:{} }. This is impossible unless we
// rename unique element to be unique.
//
// If we suffix the names, the conversion process can still reorder names to something
// like { E: {A1:{}, A2:{}, O:{} }. We solve that by makeing each renamed element
// have an increasing, sortable name, so that we can reorder the result object.
//========================================================================================
class FormulaService {

    get next() { return this.iterator.next().value; }

    get canonicalName() { return constants.EXPR_ITEM; }


    //========================================================================================
    // The following XML elmements to members of an increasing set of names.
    //  Expression
    //  Argument
    //  Operator
    //  Function
    // Each opening and closing pair name must match.
    //
    // Input : an XML string
    // Return: XML DOM document with renamed node names. Each orginal node name is set
    // into attribute "baseName" for identifcation and recovery during XML send.
    //========================================================================================
    preprocess( xmlString ){

        console.time("PREPROCESS");


        // console.time("Rename expressions");
        //PF-5906 This was handled with splits and joins because the replace all function had issues with the '/' character
        let newXMLString = xmlString.split("<Expression").join('<EXPR baseName="Expression"');
        newXMLString = newXMLString.split("</Expression>").join('</EXPR>');
        newXMLString = newXMLString.split("<Argument").join('<EXPR baseName="Argument"');
        newXMLString = newXMLString.split("</Argument>").join('</EXPR>');
        newXMLString = newXMLString.split("<Operator").join('<EXPR baseName="Operator"');
        newXMLString = newXMLString.split("</Operator>").join('</EXPR>');
        newXMLString = newXMLString.split("<Function").join('<EXPR baseName="Function"');
        newXMLString = newXMLString.split("</Function>").join('</EXPR>');
        // console.timeEnd("Rename expressions");

        const xmlDoc = xjService.stringToXmlDoc( newXMLString );
        //const xmlDoc = xjService.stringToXmlDoc( xmlString );        

        console.log("Begin preprocess");
        let
            suffixVar = 0,
            isGo = true;

        // Rename node name to a sortaable name (a member of a monotonically increasing sequence of names)
        const rename = (doc, oldNode, suffix) => {

            if ( oldNode ) {
              
                const
                    baseName = oldNode.nodeName,
                    newNode = doc.createElement( this.canonicalName );

                // Stash original name in new node's added "baseName" attribute for later name resetting.
                newNode.setAttribute('baseName', baseName);

                // Clone children
                let node = oldNode.firstChild;
                while (node) {
                    const nextNode = node.nextSibling;
                    newNode.appendChild(node);
                    node = nextNode;
                }

                // Clone attributes
                _.forEach(oldNode.attributes, v => newNode.setAttribute(v.name, v.value));

                // Replace node with new node
                oldNode.parentNode.replaceChild(newNode, oldNode);

                isGo = true;
               
            }
        };
       
        while ( isGo ) {
         isGo = false;
            _.forEach( [ 'Expression', 'Argument', 'Operator', 'Function' ],
                name => _.forEach(xmlDoc.getElementsByTagName( name ),
                    element => rename(xmlDoc, element, ++suffixVar))
            );

        }  
        console.timeEnd("PREPROCESS");    
        return xmlDoc;
    }

    //========================================================================================
    // Removes any unique sortable name from these XML elmements:
    //  Expression
    //  Argument
    //  Operator
    //  Function
    // Each opening and closing pair name must match.
    //========================================================================================
    postProcess( jsObj ){

        const xmlDoc = xjService.jsToXml( jsObj );

        // Undoes renaming of node name
        // Assume oldNode attribute "_baseName" has desired result node name.
        function undoRename(doc, oldNode)  {

            if ( oldNode ) {

                const
                    baseAttrName = 'baseName',
                    baseName = oldNode.getAttribute( baseAttrName ),
                    newNode = doc.createElement(baseName);

                // Remove baseName attribute to omit it from copy
                oldNode.removeAttribute( baseAttrName );

                // Clone children
                let node = oldNode.firstChild;
                while (node) {
                    const nextNode = node.nextSibling;
                    newNode.appendChild(node);
                    node = nextNode;
                }

                // Clone attributes
                _.forEach(oldNode.attributes, v => newNode.setAttribute(v.name, v.value));

                // Replace node with new node
                oldNode.parentNode.replaceChild(newNode, oldNode);

            }
        }

        _.forEach( ['Expression', 'Argument', 'Operator', 'Function'],
            name => _.forEach( xmlDoc.querySelectorAll( `[baseName="${name}"]` ),
                node  => undoRename(xmlDoc, node)
            )
        );

        return xmlDoc;
    }

    getFunctionParameters(type, isDataSource = false) {
        return !isDataSource ? map.get(type) : mapFunctionsDataSource.get(type);
    }

    getFunctionName(type) {
        return mapNames.get(type) || mapNamesDataSource.get(type);
    }

    getAllFunctions(){
        return mapNames.sort();
    }

    getFunctionsDataSource(){
        return mapNamesDataSource.sort();
    }

    convertExpression(expression, isDataSource = false, useScriptingParameter = false, dataSourceId) {
        let _EXPRESSION = {};
        const self = this;
        _EXPRESSION = {_id: expression.id, _type: expression.type };
        _EXPRESSION.EXPR = [];
        let args = expression.arguments || expression.Argument;
        let arg;

        _.forEach(args, function(item) {
            arg = {};

            arg._id  = listService.getCleanedId( item.id );
            arg._type = item.type;           
           
            switch (item.kind) {
                case "argument":
                case "operator":
                case "function":
                    arg = self.convertExpressionObject(item, isDataSource, dataSourceId);
                    break;
                case "grouping":
                    arg = self.convertExpressionGroup(item, isDataSource, useScriptingParameter, dataSourceId);
                    break;
            }      
            
            if (isDataSource){ //Convert Function name only if it is a reporting formula
                arg._type = self.convertFunctionNameForReports(item, isDataSource);
            }

            //PF-5023 not allow to add empty expression
            if (arg._id && arg._type){
                _EXPRESSION.EXPR.push(arg);
            } else if (item.type === 'reporting_datasourceField') {
                _EXPRESSION.EXPR.push(arg);
            }
        });


        return _EXPRESSION;
    }

    convertExpressionObject( expressionItem, isDataSource = false, dataSourceId ) {
        const self = this;
        let arg = {};
        arg._id  = listService.getCleanedId( expressionItem.id );
        arg._type = expressionItem.type;
        switch (expressionItem.kind) {
            case "argument":
                arg._baseName = 'Argument';
                switch (arg._type) {
                    case 'scripting_formField':                
                          arg._value = expressionItem.value;
                          let id = expressionItem.fieldId? expressionItem.fieldId: expressionItem.id;
                          if (id) {
                               arg._value = listService.getCleanedId(id);
                             }
                        break;
                    case 'scripting_date':    
                         arg._value = expressionItem.value;
                        if (arg._value === '[current]' || arg._value === '"[current]"') {
                           arg._value = 'now';
                        }
                        else {
                            let _date = Date.parse(expressionItem.value);
                           arg._value = dateUtil.convertDateToISOString(_date ? _date : new Date()); 
                        } 
                      break;
                    case  'scripting_literal':                
                          arg._value = expressionItem.value === "[empty]" ? "" : expressionItem.value;
                          break;
                    case  'scripting_boolean':
                    case  'reporting_boolean':
                        // PF-4074 map schizophrenic booleans. checkbox, radio buttno cols send "Yes"/"No" but bare counterpaarts send "true"/"false"
                        // Reduce arg._value to 'true' or 'false'.
                        // Note if you forget to specify a valid a truth, the following will reduce to 'false'.
                        arg._value = new Set(['true', 'yes', 'checked']).has(expressionItem.value.toString().toLowerCase()) ? 'true' : 'false';
                        if (arg._type === 'reporting_boolean'){                            
                            arg._dataType = expressionItem.dataType;
                        }
                        break;
                    case  'reporting_string':
                    case  'reporting_number':
                    case  'reporting_date':
                        arg._value = expressionItem.value
                        if (arg._value === '[current]' || arg._value === '"[current]"') {
                            arg._value = 'now';
                           }
                        arg._dataType = expressionItem.dataType;
                        break;
                    case 'reporting_datasourceField':
                        arg._value =  expressionItem.fieldId ?  expressionItem.fieldId : expressionItem.value;
                        if (!expressionItem.dataType && dataSourceId){ //PF-10319, for those filter arguments without a dataType we have to look for it in the datasource
                            expressionItem.dataType = listService.getDataSourceFieldDataType(dataSourceId, arg._value);
                        }
                        arg._dataType = expressionItem.dataType;
                        arg._caption = expressionItem.caption;
                        break;
                     default:                     
                        arg._value = expressionItem.value;
                        break;               
               }
                break;
            case "operator":
                arg._baseName = 'Operator';
                break;
            case "function":
                arg._baseName = 'Function';
                if (expressionItem.functionParameters) {

                    if (!isDataSource) {
                        arg.EXPR = [];
                        _.forEach(expressionItem.functionParameters, function (p) {
                            const _exp = self.convertExpressionObject(p.children[0], isDataSource);
                            arg.EXPR.push(_exp);
                        });
                    }
                    else{                       
                        if(expressionItem.functionParameters.length > 0){
                            arg.EXPR = [];                           

                            let newEXPR, _exp;
                            arg._type = this.convertFunctionNameForReports(expressionItem, isDataSource);

                            _.forEach(expressionItem.functionParameters, function (p) {
                                newEXPR = {};
                                newEXPR._baseName = 'Expression';
                                newEXPR.EXPR = [];
                                
                                _exp = self.convertExpressionObject(p.children[0], isDataSource);
                                newEXPR.EXPR.push(_exp);
                                arg.EXPR.push(newEXPR);
                            });                              
                           
                        }                       
                    }
                }
                break;
        }

        return arg;

    }

    convertFunctionNameForReports(item, isDataSource){
        return !isDataSource ? item.type : item.type ? item.type.replace("script_",'') : item.type;
    }

    /**There are some types of Expressions (Formulas) used for objects and behaviors which contain scriptingParameter
       The other types are the Expressions used for example in worflows' paths and notifications which use scriptingCondition
       ScriptingCondition and ScriptingParameter are used for grouping statements within formulas
       The parameter useScriptingParameter indicates which you want to use 
    **/
    convertExpressionGroup( expressionItem, isDataSource = false, useScriptingParameter = false, dataSourceId ) {
        const self = this;
        let arg = {};

        arg._baseName = 'Expression';
        arg._id = listService.getCleanedId( expressionItem.id );
        arg._type = useScriptingParameter ? 'scriptingParameter': 'scriptingCondition';
        arg.EXPR = [];

        _.forEach(expressionItem.children, function(child) {
           if (child.kind === 'grouping') {
               arg.EXPR.push( self.convertExpressionGroup( child, isDataSource, useScriptingParameter, dataSourceId) );
           } else {
               arg.EXPR.push( self.convertExpressionObject( child, isDataSource, dataSourceId ) );
           }
        });

        return arg;
    }

    convertExpressionObjectToText( expressionItem ) {
        let outputText = '';
        let self = this;

        let getSpecialFieldDescription = (value) => {
            let result = specialFormList.getSpecialFormList().find(exp => exp.value === value);
            return result? result.text : null;
        }

        switch (expressionItem.kind) {
            case "argument":
                if (expressionItem.type === 'scripting_formField') {
                    let id = expressionItem.fieldId? expressionItem.fieldId: expressionItem.id;
                    let objName = listService.determineFieldName(id);
                    if (objName) {
                        outputText = objName;
                    } else {
                        objName = listService.determineFieldName(expressionItem.value);
                        if (objName) {
                            outputText = objName;
                        }
                    }
                } else if (expressionItem.type === 'scripting_date') {
                    outputText += expressionItem.value;
                } else if (expressionItem.type === 'scripting_special') {
                    let id = expressionItem.value.replace('workflowstage_', '');
                    let obj = listService.getWorkflowStageByID( id );
                    if (obj) {
                        outputText += 'Workflow - Stage "' +obj.model.get('name') + '"';
                    } else {
                        let text = getSpecialFieldDescription(expressionItem.value);
                        if (text) {
                            outputText += text;
                        } else {
                            outputText += 'Workflow - Stage "Unspecified"';
                        }
                    }

                } else {
                    if (expressionItem.value !== '[empty]') {
                        outputText += expressionItem.value;
                    }
                }
                break;
            case "operator":
                outputText += ' ' + expressionItem.value + ' ';
                break;
            case "function":
                let funcText = self.getFunctionName(expressionItem.type) + '( ';
                if (expressionItem.functionParameters) {
                    _.forEach(expressionItem.functionParameters, function(p) {
                        if (p.children[0].value !== '[empty]') {
                            funcText += self.convertExpressionObjectToText(p.children[0]) + ',';
                        }
                    });

                    funcText = funcText.substring(0,funcText.length-1);
                    funcText += ')';
                }

                outputText += funcText;
                break;
        }

        return outputText;
    }

    convertExpressionGroupToText( expressionItem ) {
        let groupText = '( ';
        let self = this;

        _.forEach(expressionItem.children, function(child) {
            if (child.kind === 'grouping') {
                groupText += self.convertExpressionGroupToText(child);
            } else
            {
                groupText += self.convertExpressionObjectToText(child);
            }
        });

        groupText += ' )';
        return groupText;
    }

    convertExpressionToText( expression ) {
        let outputText = '';
        const self = this;
        let stop = false;

        if(expression && expression.arguments){
            _.forEach(expression.arguments, function(item) {
                if (!stop) {
                    switch (item.kind) {
                        case "argument":
                        case "function":
                            outputText += self.convertExpressionObjectToText(item);
                            break;
                        case "operator":
                            if (item.value === 'empty') {
                                stop = true;
                                outputText += ' is empty <empty>';
                            }else if (item.value === 'notempty') {
                                stop = true;
                                outputText += ' is not empty <empty>';
                            }else if (item.value === 'checked') {
                                outputText += ' = Checked (yes)';
                            }else if (item.value === 'notchecked') {
                                stop = true;
                                outputText += ' = Unchecked (no)';
                            } else {
                                outputText += self.convertExpressionObjectToText(item);
                            }
                            break;
                        case "grouping":
                            outputText += self.convertExpressionGroupToText(item);
                            break;
                    }
                }
            });
    }
        return outputText;
    }

    generateExpression(val, obj) {

        if (val && val.expression) {
            var expId = val.expression.id;
            obj.Expression = {};

            obj.Expression['_id'] = val.expression.id;
            obj.Expression['_type'] = val.expression.type;
        } 

        return expId;
    }
}

const formulaService = new FormulaService();
export default formulaService;